module.exports = {
  FichasData: () => {
    return{
      // "arquitectonica": require("../assets/datasheets/ficha-tecnica-cubiertas.pdf"),
      // "master1000": require("../assets/datasheets/ficha-tecnica-cubiertas.pdf"),
      // "sintraslapo": require("../assets/datasheets/ficha-tecnica-cubiertas.pdf"),
      // "canaleta": require("../assets/datasheets/ficha-tecnica-cubiertas.pdf"),
      // "metaldeck": require("../assets/datasheets/ficha-tecnica-entrepisos.pdf"),

      "arquitectonica": "https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-cubiertas.pdf",
      "master1000": "https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-cubiertas.pdf",
      "sintraslapo": "https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-cubiertas.pdf",
      "canaleta": "https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-cubiertas.pdf",
      "metaldeck": "https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-entrepisos.pdf",

      // LINKS DEL CLIENTE.
      // Metaldeck Galvanizado y Negro: https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-entrepisos.pdf
      // Cubiertas: https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-cubiertas.pdf
      // Perfiles: https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-perfiles.pdf
      // Tubería: https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-metaltub.pdf
      // Acero Galvanizado y/o prepintado: https://www.acesco.com.co/descargas/fichastecnicas/ficha-tecnica-acero-recubierto.pdf
    }
  }
}